/*
 Please add any 'global' z-indexes.
 Consider when using a z-index to create a new stacking context to
 keep local z-indexes contained.
 */
export var ZIndexes = {
  STICKY_HEADER: 900,
  MODAL: 999,
  LIST: 9999,
  SUGGESTION_LIST: 9999
};